const zipConfig = {
    da: {
        regex: /^\d{4}$/,
        min: 1000,
        max: 9999
    },

    no: {
        regex: /^\d{4}$/,
        min: 1,
        max: 9999
    },

    se: {
        regex: /^\d{5}$/,
        min: 10000,
        max: 99999
    },

    fi: {
        regex: /^\d{5}$/,
        min: 2,
        max: 99999
    }
}

export const isValidZipCode = (zip, country) => {
    const config = zipConfig[country]

    if (!config) return false // if no config is found, return false because the country is not supported yet

    const zipInt = parseInt(zip)

    return config.regex.test(zip)
        && zipInt >= config.min
        && zipInt <= config.max
}
